// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gk-label {
  margin: 8px 0;
}

.apexcharts-legend {
  padding: 0 !important;
}
.apexcharts-legend .apexcharts-legend-series {
  display: flex !important;
  align-items: center;
  margin-right: 1rem !important;
  margin-left: 0px !important;
}
.apexcharts-legend .apexcharts-legend-series .apexcharts-legend-marker {
  margin-right: 8px;
  width: 0.75rem !important;
  height: 0.75rem !important;
  border-radius: 0.25rem !important;
}

.apexcharts-text.apexcharts-xaxis-label:last-child:not(:nth-child(-n+4)) {
  display: none;
}

.max-width-fit {
  max-width: fit-content;
}

.max-width-full {
  max-width: 100%;
}

.width-fit {
  width: fit-content;
}

.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.h-max-content {
  height: max-content;
}

.charts-tool-tip {
  background-color: white;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
}
.charts-tool-tip .font-medium {
  font-weight: 500;
}
.charts-tool-tip .text-xs {
  font-size: 0.75rem;
}
.charts-tool-tip .flex {
  display: flex;
}
.charts-tool-tip .items-center {
  align-items: center;
}
.charts-tool-tip .w-full {
  width: 100%;
}
.charts-tool-tip .justify-between {
  justify-content: space-between;
}
.charts-tool-tip .w-2-3 {
  width: 66.666667%;
}
.charts-tool-tip .min-w-5 {
  min-width: 5px;
}
.charts-tool-tip .min-h-5 {
  min-height: 5px;
}
.charts-tool-tip .rounded-full {
  border-radius: 99999px;
}
.charts-tool-tip .ml-2 {
  margin-left: 0.5rem;
}
.charts-tool-tip .text-gray-500 {
  color: rgb(107, 114, 128);
}
.charts-tool-tip .text-10px {
  font-size: 10px;
}
.charts-tool-tip .w-1-3 {
  width: 33.333333%;
}
.charts-tool-tip .text-right {
  text-align: right;
}
.charts-tool-tip .font-bold {
  font-weight: 700;
}

.gk-menu.ant-menu-light {
  background-color: #002d55;
}
.gk-menu.ant-menu-light .ant-menu-item {
  margin-inline: 0;
  margin-bottom: 4px;
  width: 100%;
  border-radius: 0;
  background-color: #002d55;
  color: #fff;
}
.gk-menu.ant-menu-light .ant-menu-item:not(.ant-menu-item-selected):active {
  background-color: #003c71;
}
.gk-menu.ant-menu-light .ant-menu-item:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected):hover {
  color: #fff;
}
.gk-menu.ant-menu-light .ant-menu-submenu {
  background-color: #002d55;
  color: #fff;
  margin-bottom: 4px;
}
.gk-menu.ant-menu-light .ant-menu-submenu.ant-menu-submenu-open {
  background-color: #003c71;
  color: #fff;
  border-radius: 8px;
}
.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title {
  margin-inline: 0;
  margin-bottom: 0;
  width: 100%;
  border-radius: 8px;
}
.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title:active {
  background-color: #003c71;
}
.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title:hover {
  color: #fff;
}
.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item {
  border-radius: 8px;
  background-color: #003c71;
  margin-block: 0;
  padding: 8px 40px;
}
.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item.ant-menu-item-selected {
  background-color: #003c71;
  color: #fff;
}
.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item:hover {
  color: #fff;
}
.gk-menu.ant-menu-light .ant-menu-submenu.ant-menu-submenu-selected .ant-menu-submenu-title {
  background-color: #003c71;
  color: #fff;
}
.gk-menu.ant-menu-light .ant-menu-title-content {
  font-size: 13px;
  line-height: 16px;
}
.gk-menu.ant-menu-light .ant-menu-item-selected {
  background-color: #003c71;
  color: #fff;
  border-radius: 8px;
}
.gk-menu.ant-menu-light .ant-menu-item-selected .ant-menu-title-content,
.gk-menu.ant-menu-light .ant-menu-submenu-title .ant-menu-title-content {
  font-weight: 500;
}

.ant-menu-submenu.ant-menu-submenu-popup.ant-menu-submenu-open {
  border-radius: 8px;
  padding-left: 8px;
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-submenu-title {
  margin-inline: 0;
  margin-bottom: 0;
  width: 100%;
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-submenu-title:active {
  background-color: #003c71;
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {
  background-color: #003c71;
  color: #fff;
  margin-block: 0;
  margin-inline: 0;
  border-radius: 0;
  width: 100%;
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item.ant-menu-item-selected {
  background-color: #003c71;
  color: #fff;
}
.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected):hover {
  color: #fff;
  background-color: #003c71;
}
.ant-menu-submenu.ant-menu-submenu-popup.ant-menu-submenu-selected .ant-menu-submenu-title {
  background-color: #003c71;
  color: #fff;
}

.ant-tooltip.ant-menu-inline-collapsed-tooltip .ant-tooltip-arrow {
  display: none;
}
.ant-tooltip.ant-menu-inline-collapsed-tooltip .ant-tooltip-content .ant-tooltip-inner {
  margin-left: 0px;
  border-radius: 4px;
  background-color: #003c71;
  color: #fff;
  font-size: 13px;
  line-height: 16px;
}

.gk-select.ant-select.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector, .gk-select.ant-select.ant-select-focused.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {
  border-color: #d0d5dd;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.gk-select.ant-select.removable-select-filled:hover .ant-select-arrow {
  opacity: 1;
}
.gk-select.ant-select.removable-select-filled:hover .ant-select-arrow .anticon-down {
  display: none;
}
.gk-select.ant-select .remove-icon {
  font-size: 1rem;
  line-height: 1.5;
  background-color: #fff;
  color: #d60000;
  position: absolute;
  top: -19px;
  right: -14px;
}

.ant-tabs {
  width: 100%;
  max-width: 100%;
}

.gk-ant-table .ant-table-cell {
  font-family: Inter;
}
.gk-ant-table .ant-table-wrapper .ant-table-thead tr th.ant-table-cell {
  color: #737a87;
  border-top: 2px solid #f0f0f0;
  padding: 10px;
}
.gk-ant-table .ant-table-wrapper .ant-table-tbody tr td.ant-table-cell {
  border-top: 1px solid #f0f0f0;
  padding: 10px;
}
.gk-ant-table .ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:first-child {
  border-start-start-radius: 0px;
}
.gk-ant-table .ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:last-child {
  border-start-end-radius: 0px;
}
.gk-ant-table .ant-table-pagination {
  padding-left: 12px;
}
.gk-ant-table .ant-table-pagination .ant-pagination .ant-pagination-total-text {
  min-width: 250px;
}

.gk-tag {
  padding: 0.25rem;
}
.gk-tag.warning {
  color: #faad14;
  background: #fffcf5;
  border: 0.6px solid #fedf89;
}
.gk-tag.success {
  color: #079455;
  background: #f6fef9;
  border: 0.6px solid #abefc6;
}
.gk-tag.error {
  color: #d92d20;
  background: #fffbfa;
  border: 0.6px solid #fecdca;
}
.gk-tag.default {
  color: #003c71;
  background: #f5fbff;
  border: 0.6px solid #b9e6fe;
}

.ant-checkbox-indeterminate .ant-checkbox-inner {
  border-color: #004b8d;
}

.gk-text-input .remove-icon {
  font-size: 1rem;
  line-height: 1.5;
  background-color: #fff;
  color: #d60000;
  position: absolute;
  top: -6px;
  right: -4px;
}

.chip-input-grow {
  flex-grow: 1;
}

.chip-width {
  width: max-content;
}

.summary-blocks {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: #d1d5db;
  border-style: solid;
  background-color: #fff;
}
.summary-blocks .summary-block {
  flex: 1 1 auto;
}
.summary-blocks .summary-block.summary-block-bordered {
  border-width: 0;
  border-color: #d1d5db;
  border-style: solid;
  border-right-width: 1px;
}
.summary-blocks .summary-block .summary-title {
  color: #9ca3af;
  font-weight: 500;
}
.summary-blocks .skeleton {
  height: 1rem;
}
.summary-blocks .summary-value {
  align-self: flex-start;
  font-weight: 600;
}
.summary-blocks .mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.analytics-wrapper {
  display: flex;
  padding: 1rem;
  flex-direction: column;
  row-gap: 0.75rem;
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: #d1d5db;
  border-style: solid;
  min-height: 300px;
  height: 100%;
  background-color: #fff;
}
.analytics-wrapper .wrapper-hero-value {
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 2rem;
}
.analytics-wrapper .w-32 {
  width: 8rem;
}
.analytics-wrapper .grow-children {
  flex-grow: 1;
  width: 100%;
}
.analytics-wrapper .uppercase {
  text-transform: uppercase;
}
.analytics-wrapper .lowercase {
  text-transform: lowercase;
}

.custom-date-range-picker {
  position: relative;
  cursor: pointer;
}
.custom-date-range-picker .ant-picker.ant-picker-range.hide-end-date .ant-picker-range-separator {
  display: none;
}
.custom-date-range-picker .ant-picker.ant-picker-range.hide-end-date div:nth-of-type(3) {
  display: none;
}
.custom-date-range-picker .ant-picker.ant-picker-range .ant-picker-input input {
  text-align: center;
}

.date-picker-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100vh;
}

.custom-picker-preset {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-family: "Inter";
}
.custom-picker-preset.custom-picker-selected-preset {
  font-weight: 500;
  color: #003c71;
}

.custom-picker-footer {
  padding-block: 0.5rem;
  padding-inline-end: 0.5rem;
}

.analytics-wrapper .text-success-500,
.summary-blocks .text-success-500 {
  color: #079455;
}
.analytics-wrapper .text-error-500,
.summary-blocks .text-error-500 {
  color: #d92d20;
}
.analytics-wrapper .text-gray-400,
.summary-blocks .text-gray-400 {
  color: rgb(156, 163, 175);
}
.analytics-wrapper .text-gray-500,
.summary-blocks .text-gray-500 {
  color: rgb(107, 114, 128);
}
.analytics-wrapper .text-xs,
.summary-blocks .text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.analytics-wrapper .text-sm,
.summary-blocks .text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.analytics-wrapper .font-normal,
.summary-blocks .font-normal {
  font-weight: 400;
}
.analytics-wrapper .font-medium,
.summary-blocks .font-medium {
  font-weight: 500;
}
.analytics-wrapper .text-center,
.summary-blocks .text-center {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./node_modules/gokwik-ui-kit/dist/esm/bundle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB","sourcesContent":[".gk-label {\n  margin: 8px 0;\n}\n\n.apexcharts-legend {\n  padding: 0 !important;\n}\n.apexcharts-legend .apexcharts-legend-series {\n  display: flex !important;\n  align-items: center;\n  margin-right: 1rem !important;\n  margin-left: 0px !important;\n}\n.apexcharts-legend .apexcharts-legend-series .apexcharts-legend-marker {\n  margin-right: 8px;\n  width: 0.75rem !important;\n  height: 0.75rem !important;\n  border-radius: 0.25rem !important;\n}\n\n.apexcharts-text.apexcharts-xaxis-label:last-child:not(:nth-child(-n+4)) {\n  display: none;\n}\n\n.max-width-fit {\n  max-width: fit-content;\n}\n\n.max-width-full {\n  max-width: 100%;\n}\n\n.width-fit {\n  width: fit-content;\n}\n\n.truncate-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.h-max-content {\n  height: max-content;\n}\n\n.charts-tool-tip {\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem;\n}\n.charts-tool-tip .font-medium {\n  font-weight: 500;\n}\n.charts-tool-tip .text-xs {\n  font-size: 0.75rem;\n}\n.charts-tool-tip .flex {\n  display: flex;\n}\n.charts-tool-tip .items-center {\n  align-items: center;\n}\n.charts-tool-tip .w-full {\n  width: 100%;\n}\n.charts-tool-tip .justify-between {\n  justify-content: space-between;\n}\n.charts-tool-tip .w-2-3 {\n  width: 66.666667%;\n}\n.charts-tool-tip .min-w-5 {\n  min-width: 5px;\n}\n.charts-tool-tip .min-h-5 {\n  min-height: 5px;\n}\n.charts-tool-tip .rounded-full {\n  border-radius: 99999px;\n}\n.charts-tool-tip .ml-2 {\n  margin-left: 0.5rem;\n}\n.charts-tool-tip .text-gray-500 {\n  color: rgb(107, 114, 128);\n}\n.charts-tool-tip .text-10px {\n  font-size: 10px;\n}\n.charts-tool-tip .w-1-3 {\n  width: 33.333333%;\n}\n.charts-tool-tip .text-right {\n  text-align: right;\n}\n.charts-tool-tip .font-bold {\n  font-weight: 700;\n}\n\n.gk-menu.ant-menu-light {\n  background-color: #002d55;\n}\n.gk-menu.ant-menu-light .ant-menu-item {\n  margin-inline: 0;\n  margin-bottom: 4px;\n  width: 100%;\n  border-radius: 0;\n  background-color: #002d55;\n  color: #fff;\n}\n.gk-menu.ant-menu-light .ant-menu-item:not(.ant-menu-item-selected):active {\n  background-color: #003c71;\n}\n.gk-menu.ant-menu-light .ant-menu-item:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected):hover {\n  color: #fff;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu {\n  background-color: #002d55;\n  color: #fff;\n  margin-bottom: 4px;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu.ant-menu-submenu-open {\n  background-color: #003c71;\n  color: #fff;\n  border-radius: 8px;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title {\n  margin-inline: 0;\n  margin-bottom: 0;\n  width: 100%;\n  border-radius: 8px;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title:active {\n  background-color: #003c71;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-submenu-title:hover {\n  color: #fff;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item {\n  border-radius: 8px;\n  background-color: #003c71;\n  margin-block: 0;\n  padding: 8px 40px;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item.ant-menu-item-selected {\n  background-color: #003c71;\n  color: #fff;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu .ant-menu-sub .ant-menu-item:hover {\n  color: #fff;\n}\n.gk-menu.ant-menu-light .ant-menu-submenu.ant-menu-submenu-selected .ant-menu-submenu-title {\n  background-color: #003c71;\n  color: #fff;\n}\n.gk-menu.ant-menu-light .ant-menu-title-content {\n  font-size: 13px;\n  line-height: 16px;\n}\n.gk-menu.ant-menu-light .ant-menu-item-selected {\n  background-color: #003c71;\n  color: #fff;\n  border-radius: 8px;\n}\n.gk-menu.ant-menu-light .ant-menu-item-selected .ant-menu-title-content,\n.gk-menu.ant-menu-light .ant-menu-submenu-title .ant-menu-title-content {\n  font-weight: 500;\n}\n\n.ant-menu-submenu.ant-menu-submenu-popup.ant-menu-submenu-open {\n  border-radius: 8px;\n  padding-left: 8px;\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-submenu-title {\n  margin-inline: 0;\n  margin-bottom: 0;\n  width: 100%;\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-submenu-title:active {\n  background-color: #003c71;\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item {\n  background-color: #003c71;\n  color: #fff;\n  margin-block: 0;\n  margin-inline: 0;\n  border-radius: 0;\n  width: 100%;\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item.ant-menu-item-selected {\n  background-color: #003c71;\n  color: #fff;\n}\n.ant-menu-submenu.ant-menu-submenu-popup .ant-menu-sub .ant-menu-item:not(.ant-menu-item-selected):not(.ant-menu-submenu-selected):hover {\n  color: #fff;\n  background-color: #003c71;\n}\n.ant-menu-submenu.ant-menu-submenu-popup.ant-menu-submenu-selected .ant-menu-submenu-title {\n  background-color: #003c71;\n  color: #fff;\n}\n\n.ant-tooltip.ant-menu-inline-collapsed-tooltip .ant-tooltip-arrow {\n  display: none;\n}\n.ant-tooltip.ant-menu-inline-collapsed-tooltip .ant-tooltip-content .ant-tooltip-inner {\n  margin-left: 0px;\n  border-radius: 4px;\n  background-color: #003c71;\n  color: #fff;\n  font-size: 13px;\n  line-height: 16px;\n}\n\n.gk-select.ant-select.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer):hover .ant-select-selector, .gk-select.ant-select.ant-select-focused.ant-select:not(.ant-select-disabled):not(.ant-select-customize-input):not(.ant-pagination-size-changer) .ant-select-selector {\n  border-color: #d0d5dd;\n  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n}\n.gk-select.ant-select.removable-select-filled:hover .ant-select-arrow {\n  opacity: 1;\n}\n.gk-select.ant-select.removable-select-filled:hover .ant-select-arrow .anticon-down {\n  display: none;\n}\n.gk-select.ant-select .remove-icon {\n  font-size: 1rem;\n  line-height: 1.5;\n  background-color: #fff;\n  color: #d60000;\n  position: absolute;\n  top: -19px;\n  right: -14px;\n}\n\n.ant-tabs {\n  width: 100%;\n  max-width: 100%;\n}\n\n.gk-ant-table .ant-table-cell {\n  font-family: Inter;\n}\n.gk-ant-table .ant-table-wrapper .ant-table-thead tr th.ant-table-cell {\n  color: #737a87;\n  border-top: 2px solid #f0f0f0;\n  padding: 10px;\n}\n.gk-ant-table .ant-table-wrapper .ant-table-tbody tr td.ant-table-cell {\n  border-top: 1px solid #f0f0f0;\n  padding: 10px;\n}\n.gk-ant-table .ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:first-child {\n  border-start-start-radius: 0px;\n}\n.gk-ant-table .ant-table-wrapper .ant-table-container table > thead > tr:first-child > *:last-child {\n  border-start-end-radius: 0px;\n}\n.gk-ant-table .ant-table-pagination {\n  padding-left: 12px;\n}\n.gk-ant-table .ant-table-pagination .ant-pagination .ant-pagination-total-text {\n  min-width: 250px;\n}\n\n.gk-tag {\n  padding: 0.25rem;\n}\n.gk-tag.warning {\n  color: #faad14;\n  background: #fffcf5;\n  border: 0.6px solid #fedf89;\n}\n.gk-tag.success {\n  color: #079455;\n  background: #f6fef9;\n  border: 0.6px solid #abefc6;\n}\n.gk-tag.error {\n  color: #d92d20;\n  background: #fffbfa;\n  border: 0.6px solid #fecdca;\n}\n.gk-tag.default {\n  color: #003c71;\n  background: #f5fbff;\n  border: 0.6px solid #b9e6fe;\n}\n\n.ant-checkbox-indeterminate .ant-checkbox-inner {\n  border-color: #004b8d;\n}\n\n.gk-text-input .remove-icon {\n  font-size: 1rem;\n  line-height: 1.5;\n  background-color: #fff;\n  color: #d60000;\n  position: absolute;\n  top: -6px;\n  right: -4px;\n}\n\n.chip-input-grow {\n  flex-grow: 1;\n}\n\n.chip-width {\n  width: max-content;\n}\n\n.summary-blocks {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  border-radius: 0.5rem;\n  border-width: 1px;\n  border-color: #d1d5db;\n  border-style: solid;\n  background-color: #fff;\n}\n.summary-blocks .summary-block {\n  flex: 1 1 auto;\n}\n.summary-blocks .summary-block.summary-block-bordered {\n  border-width: 0;\n  border-color: #d1d5db;\n  border-style: solid;\n  border-right-width: 1px;\n}\n.summary-blocks .summary-block .summary-title {\n  color: #9ca3af;\n  font-weight: 500;\n}\n.summary-blocks .skeleton {\n  height: 1rem;\n}\n.summary-blocks .summary-value {\n  align-self: flex-start;\n  font-weight: 600;\n}\n.summary-blocks .mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.analytics-wrapper {\n  display: flex;\n  padding: 1rem;\n  flex-direction: column;\n  row-gap: 0.75rem;\n  border-radius: 0.5rem;\n  border-width: 1px;\n  border-color: #d1d5db;\n  border-style: solid;\n  min-height: 300px;\n  height: 100%;\n  background-color: #fff;\n}\n.analytics-wrapper .wrapper-hero-value {\n  font-weight: 600;\n  font-size: 1.5rem;\n  line-height: 2rem;\n}\n.analytics-wrapper .w-32 {\n  width: 8rem;\n}\n.analytics-wrapper .grow-children {\n  flex-grow: 1;\n  width: 100%;\n}\n.analytics-wrapper .uppercase {\n  text-transform: uppercase;\n}\n.analytics-wrapper .lowercase {\n  text-transform: lowercase;\n}\n\n.custom-date-range-picker {\n  position: relative;\n  cursor: pointer;\n}\n.custom-date-range-picker .ant-picker.ant-picker-range.hide-end-date .ant-picker-range-separator {\n  display: none;\n}\n.custom-date-range-picker .ant-picker.ant-picker-range.hide-end-date div:nth-of-type(3) {\n  display: none;\n}\n.custom-date-range-picker .ant-picker.ant-picker-range .ant-picker-input input {\n  text-align: center;\n}\n\n.date-picker-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  width: 100%;\n  height: 100vh;\n}\n\n.custom-picker-preset {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-family: \"Inter\";\n}\n.custom-picker-preset.custom-picker-selected-preset {\n  font-weight: 500;\n  color: #003c71;\n}\n\n.custom-picker-footer {\n  padding-block: 0.5rem;\n  padding-inline-end: 0.5rem;\n}\n\n.analytics-wrapper .text-success-500,\n.summary-blocks .text-success-500 {\n  color: #079455;\n}\n.analytics-wrapper .text-error-500,\n.summary-blocks .text-error-500 {\n  color: #d92d20;\n}\n.analytics-wrapper .text-gray-400,\n.summary-blocks .text-gray-400 {\n  color: rgb(156, 163, 175);\n}\n.analytics-wrapper .text-gray-500,\n.summary-blocks .text-gray-500 {\n  color: rgb(107, 114, 128);\n}\n.analytics-wrapper .text-xs,\n.summary-blocks .text-xs {\n  font-size: 0.75rem;\n  line-height: 1rem;\n}\n.analytics-wrapper .text-sm,\n.summary-blocks .text-sm {\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n}\n.analytics-wrapper .font-normal,\n.summary-blocks .font-normal {\n  font-weight: 400;\n}\n.analytics-wrapper .font-medium,\n.summary-blocks .font-medium {\n  font-weight: 500;\n}\n.analytics-wrapper .text-center,\n.summary-blocks .text-center {\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
